import OrderDTO from "@/dto/order/OrderDTO";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { CaretUpOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Dropdown, Spin } from "antd";
import React, { useState } from "react";
import OtherOperationMenu from "./components/OtherOperationMenu";
import { observer } from "mobx-react-lite";

interface OtherOperationsButtonProps {
    tab: OrderTab;
    shop: ShopDTO;
    getSelectedOrders(): OrderDTO[];
    isSupplierShop: boolean;
}

const OtherOperationsButton: React.FC<OtherOperationsButtonProps> = function (props) {
    const [loading, setLoading] = useState(false);

    return (
        <Dropdown menu={{ items: [] }}
            popupRender={() => {
                return <OtherOperationMenu {...props} onLoadingChange={setLoading} />;
            }}
            placement="topLeft"
            trigger={["click"]}
            disabled={loading}
        >
            <Button type="primary" className="ant-btn-gray" style={{ borderColor: "transparent" }}>
                {loading && <Spin indicator={<LoadingOutlined style={{ color: "#fff", marginRight: "10px" }} />} />}
                其他操作
                <CaretUpOutlined />
            </Button>
        </Dropdown>
    );
};

export default observer(OtherOperationsButton);
